import SpriteSymbol from "../../../node_modules/.store/svg-baker-runtime@1.4.7/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/.store/svg-sprite-loader@6.0.11/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-tz",
  "use": "icon-tz-usage",
  "viewBox": "0 0 6 14",
  "content": "<symbol viewBox=\"0 0 6 14\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-tz\">\r\n<path id=\"icon-tz_Vector\" opacity=\"0.6\" d=\"M0 4H2V6H0V4ZM0 0H2V2H0V0ZM0 8H2V10H0V8ZM0 12H2V14H0V12ZM4 4H6V6H4V4ZM4 0H6V2H4V0ZM4 8H6V10H4V8ZM4 12H6V14H4V12Z\" fill=\"#8B909F\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol